import React, { useState, useRef } from 'react';
import { ClipboardDocumentIcon } from '@heroicons/react/24/outline';

const NOTION_ICON = 'https://auth.openorg.fyi/storage/v1/object/public/web-assets/notion_icon.png';
const SLACK_ICON = 'https://auth.openorg.fyi/storage/v1/object/public/web-assets/slack-new-logo.svg';

const CopyToNotion = ({ children, title, className = "", slack = false }) => {
  const [copied, setCopied] = useState(false);
  const contentRef = useRef(null);
  const uniqueId = useRef(`notion-copy-${Math.random().toString(36).substring(2, 11)}`);

  const handleCopy = () => {
    const textToCopy = contentRef.current ? contentRef.current.innerText : '';
    navigator.clipboard.writeText(textToCopy).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }).catch(err => {
      console.error('Failed to copy text: ', err);
    });
  };

  const icon = slack ? SLACK_ICON : NOTION_ICON;
  const buttonLabel = slack ? 'Copy Slack Message' : 'Copy to Clipboard';

  return (
    <div className={`my-6 bg-gray-900/70 border border-gray-700/70 rounded-lg overflow-hidden shadow-lg ${className}`}>
      {/* Header */}
      {title && (
        <div className="flex items-center p-4 border-b border-gray-700/50">
          <img
            src={icon}
            alt={slack ? 'Slack icon' : 'Notion icon'}
            className="h-5 w-5 mr-2 rounded object-contain bg-gray-800"
            style={{ background: '#23272f' }}
          />
          <span className="font-semibold text-white">{title}</span>
        </div>
      )}
      
      {/* Content */}
      <div 
        id={uniqueId.current}
        ref={contentRef}
        className="p-5 text-gray-200 font-light leading-relaxed prose prose-invert max-w-none"
      >
        {children}
      </div>
      
      {/* Footer with Copy Button */}
      <div className="p-3 bg-gray-800/50 border-t border-gray-700/50 flex justify-end">
        <button
          onClick={handleCopy}
          className="flex items-center bg-gray-700 hover:bg-gray-600 transition-colors px-4 py-2 rounded-md text-sm font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
        >
          {copied ? (
            <>
              <CheckIcon className="h-4 w-4 mr-2 text-green-400" />
              Copied!
            </>
          ) : (
            <>
              <ClipboardDocumentIcon className="h-4 w-4 mr-2 text-primary" />
              {buttonLabel}
            </>
          )}
        </button>
      </div>
    </div>
  );
};

// Check icon component
const CheckIcon = ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
  </svg>
);

export default CopyToNotion; 